export default __webpack_public_path__ + "static/media/provider_2.491f9cb8.png";